import { ReactNode } from "react";
import { Pager } from "shared/ui";
import type { PeoplePageState } from "../../model/useRafflePeoplePage";

import styles from "./RaffleDetailPage.module.css";

interface Props<Item> {
  state: PeoplePageState<Item>;
  emptyText: string;
  renderTable: (items: Item[], offset: number) => ReactNode;
}

// Общая обвязка таблиц участников и победителей: состояния + пагинация.
export const PeopleSection = <Item,>({
  state,
  emptyText,
  renderTable,
}: Props<Item>) => {
  const { items, page, pages, setPage, isLoading, isFetching } = state;

  const renderBody = () => {
    if (isLoading) return <p className={styles.placeholder}>Loading...</p>;
    if (state.errorMessage && !items.length) {
      return <p className={styles.placeholder}>{state.errorMessage}</p>;
    }
    if (!items.length) return <p className={styles.placeholder}>{emptyText}</p>;
    return (
      <div className={`${styles.table} ${isFetching ? styles.fetching : ""}`}>
        {renderTable(items, state.offset)}
      </div>
    );
  };

  return (
    <>
      {renderBody()}
      <Pager
        page={page}
        pages={pages}
        disabled={isFetching}
        onChange={setPage}
      />
    </>
  );
};
